import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Badge, Card, Container, Dropdown } from 'react-bootstrap'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import { FaBus } from 'react-icons/fa'
import { LuGraduationCap } from 'react-icons/lu'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'
import { useNavigate } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { BsEyeFill, BsPersonPlusFill, BsThreeDotsVertical } from 'react-icons/bs'
import ApiEndpoints from './commonComponents/ApiEndpoints'
import { Modal, Form } from "react-bootstrap";
import EditBusModal from './EditBusModal'
import { toast } from 'react-hot-toast';
import { BsPencilFill} from 'react-icons/bs'
import { MdOutlineDeleteForever } from "react-icons/md";
import DeleteBusModal from './DeleteBusModal'
import { MdAssignmentAdd } from "react-icons/md";
import { GrView } from "react-icons/gr";
import { BsFunnelFill } from 'react-icons/bs'
import { BsSearch } from 'react-icons/bs'
import { BsArrowClockwise } from 'react-icons/bs'
import {Row,Col} from 'react-bootstrap'
import { useBusJourneyTracking } from './trackVehicle/useBusJourneyTracking'
import { TrackVehicleButton } from './trackVehicle/VehicleTrackingModal'
import { isBusAttendantUser } from '../utils/busAttendant'

export default function ManageBus() {
  const { logout, user } = useAuth()
  const { isCollapsed } = useSidebar()
  const navigate = useNavigate()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();


  // adding bus data
  const [buses, setBuses] = useState([]);
  /** user id -> display name for bus attendants (from `/get/users/bus-attendants`) */
  const [attendantNamesById, setAttendantNamesById] = useState({});
  // const [loading, setLoading] = useState(false);


const [showEditModal, setShowEditModal] = useState(false);
const [selectedBus, setSelectedBus] = useState(null);
  const [mode, setMode] = useState(""); // "view" or "edit"

  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);
 



// search pagination 
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
    const [showModal, setShowModal] = useState(false)
  const [showFilterCard, setShowFilterCard] = useState(true)
const [selectedCourse, setSelectedCourse] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
    const [selectedStudent, setSelectedStudent] = useState('');
    const [selectedStudentFull, setSelectedStudentFull] = useState(null);
    const [selectedStudentId, setSelectedStudentId] = useState('');
    const [allStudents, setAllStudents] = useState([])
    const [search, setSearch] = useState('')

  const [journeyActiveByBusId, setJourneyActiveByBusId] = useState({})

  const { inFlight } = useBusJourneyTracking()

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1
        setMarginLeft(
          isCollapsed ? `${collapsedWidth + gap}px` : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }
      setIsMobile(window.innerWidth <= 768)
    }

    
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])






const fetchBuses = useCallback(async () => {
  try {
    const res = await ApiEndpoints.getAllBuses()
    const list = res?.data?.data || []
    setBuses(list)

    // Keep journey status in sync with backend so the "Journey live" badge updates
    // even if the attendant started the journey from AttendantPortal.
    const nextJourney = {}
    for (const b of Array.isArray(list) ? list : []) {
      const id = Number(b?.bus_id ?? b?.id)
      if (!Number.isFinite(id) || id <= 0) continue
      const st = (b?.bus_journey_status ?? b?.busJourneyStatus ?? '')
      nextJourney[id] = String(st).toLowerCase() === 'started'
    }
    setJourneyActiveByBusId(nextJourney)
  } catch (error) {
    console.error('Error fetching buses:', error)
  }
}, [])

const fetchAttendantLookup = useCallback(async () => {
  try {
    const res = await ApiEndpoints.getBusAttendants();
    const list = res.data?.data ?? res.data ?? [];
    const map = {};
    for (const a of Array.isArray(list) ? list : []) {
      const uid = a.id ?? a.user_id;
      if (uid == null) continue;
      const label =
        a.name ||
        [a.first_name, a.last_name].filter(Boolean).join(" ") ||
        a.email ||
        `User #${uid}`;
      map[Number(uid)] = label;
    }
    setAttendantNamesById(map);
  } catch (error) {
    console.error("Error fetching bus attendants:", error);
    setAttendantNamesById({});
  }
}, []);

useEffect(() => {
  fetchBuses()
  fetchAttendantLookup()
}, [fetchBuses, fetchAttendantLookup])

useEffect(() => {
  const t = window.setInterval(() => {
    fetchBuses()
  }, 15000)
  return () => window.clearInterval(t)
}, [fetchBuses])


  const handleRefresh = () => {
    // clear selected filters
    setSelectedCourse("");
    setSelectedClass("");
    setSelectedStudentId("");
    setSearch("");

    fetchBuses();
    fetchAttendantLookup();
  };


// const handleView = (bus) => {
//   setSelectedBus(bus);
//   setMode("view");
//   setShowEditModal(true);
// };

  const handleViewAssignedStd = (bus) => {
    navigate(`/ViewBusAssignedStudent/${bus.bus_id}`, { state: { bus } })
  }

  const handleAssiginBustoStudent=(bus)=>{
    console.log("Selected Bus",bus)  // debug
    navigate(`/AssigningBustoStd/${bus.bus_id}`)
  }

const handleEdit = (bus) => {
  setSelectedBus(bus);
  setMode("edit");
  setShowEditModal(true);
};

  const handleTrackVehicle = useCallback(
    ({ busId }) => {
      const id = Number(busId)
      if (!Number.isFinite(id) || id <= 0) return
      navigate(`/vehicle/track/${id}`)
    },
    [navigate],
  )

const filteredBuses = useMemo(() => {
  if (!search.trim()) return buses;
  const q = search.trim().toLowerCase();
  return buses.filter((bus) => {
    const attendantLabel =
      bus.bus_attendant_id == null
        ? "not assigned"
        : (
            attendantNamesById[bus.bus_attendant_id] ||
            attendantNamesById[String(bus.bus_attendant_id)] ||
            ""
          ).toLowerCase();
    const matchesFields = Object.values(bus).some(
      (val) =>
        val != null &&
        val !== "" &&
        val.toString().toLowerCase().includes(q),
    );
    return matchesFields || attendantLabel.includes(q);
  });
}, [buses, search, attendantNamesById]);


const totalPages = Math.ceil(filteredBuses.length / itemsPerPage);

const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;

const currentBuses = filteredBuses.slice(
  indexOfFirstItem,
  indexOfLastItem
);

useEffect(() => {
  setCurrentPage(1);
}, [search, itemsPerPage]);

// const handleDelete = async (id) => {
//   // if (!window.confirm("Are sure to delete this")) return;

//   try {
//     await ApiEndpoints.deleteBus(deleteId);
//     toast.success("Deleted ✅");
//     // alert("Bus Deleted Successfully ✅");

//     setBuses((prev) => prev.filter((b) => b.bus_id !== deleteId));
//     setShowDeleteModal(false)
//   } catch (err) {
//     console.error(err);
//   }
// };

// 


// const handleUpdate = async () => {
//   try {
//     await ApiEndpoints.updateBus(selectedBus.bus_id, {
//       bus_number: selectedBus.bus_number,
//       driver_name: selectedBus.driver_name,
//       driver_contact_number: selectedBus.driver_contact_number,
//       bus_owner_name: selectedBus.bus_owner_name,
//     });

//     toast.success("Updated ✅");
//     // alert("Bus Updated Successfully✅");
//     setShowEditModal(false);

//     // refresh UI
//     setBuses((prev) =>
//       prev.map((b) =>
//         b.bus_id === selectedBus.bus_id ? selectedBus : b
//       )
//     );
//   } catch (err) {
//     console.error(err);
//   }
// };


  
  return (
    <>
      <style>
        {`
          .page-title {
            font-family: 'Inter', system-ui, sans-serif;
            letter-spacing: -0.02em;
            color: #223843;
          }
          .modern-card {
            background: #ffffff;
            border: 1px solid #D1D3D4;
            border-radius: 12px;
            overflow: hidden;
          }
          /* Match CreateNotification.js premium table behavior */
          .table td {
            overflow: visible !important;
            user-select: text;
          }
          .table tbody tr {
            overflow: visible !important;
            cursor: default;
          }
          .table-card {
            overflow: visible !important;
          }
          .table-wrapper {
            overflow-x: auto;
            overflow-y: visible !important;
            position: relative;
          }
          .table td, .table th { user-select: text; }

          /* Dropdown menu over table (like AddGuardian.js) */
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }
          .table td {
            overflow: visible !important;
          }
          .table tbody tr {
            overflow: visible !important;
          }
          .dropdown-menu {
            z-index: 9999 !important;
            position: absolute !important;
          }
        `}
      </style>

      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: '12px',
          paddingRight: '12px'}}
      >

        
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
                gap: '12px'}}
            >
              <div
                className="d-flex align-items-center gap-3"
                style={{ flex: 1, minWidth: 0 }}
              >
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    background: '#223843',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0}}
                >
                  {!logoError ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>
                <div style={{ minWidth: 0 }}>
                  <h3
                    className="m-0 fw-bold page-title text-start"
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontSize: isMobile ? '14px' : 'clamp(18px, 2.5vw, 22px)',
                      lineHeight: '1.2'}}
                  >
                    Manage Transport
                  </h3>
                  <p
                    className="m-0 mt-0 text-start"
                    style={{ fontSize: isMobile ? '10px' : '13px', color: '#6b7280' }}
                  >
                    View and Manage Vehicle.
                  </p>
                </div>

              </div>

              {!isMobile && (
                <div className="d-flex align-items-center gap-3" style={{ justifyContent: 'flex-end' }}>
                  <ProfileDropdown
                    logout={logout}
                    notificationCount={3}
                    showNotifications={true}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <Container
          fluid
          className="p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >
             {/* adding Shoe pagination and filter */}
             
        

                    <div className="d-flex justify-content-between align-items-center mb-4">
  
  {/* LEFT SIDE */}
  <div className="d-flex align-items-center gap-3">
    
    {/* Show Per Page */}
    <div 
      className="d-flex align-items-center"
      style={{
        backgroundColor: '#ffffff',
        padding: '8px 16px',
        borderRadius: '8px',
        gap: '8px',
        border: '1px solid #D1D3D4'}}
    >
      <span style={{ fontSize: '13px', color: '#6b7280' }}>
        Show:
      </span>

      <Form.Select
        value={itemsPerPage}
        onChange={(e) => {
          setItemsPerPage(parseInt(e.target.value))
          setCurrentPage(1)
        }}
        style={{
          height: '36px',
          fontSize: '13px',
          borderRadius: '6px'}}
      >
        <option value="10">10 per page</option>
        <option value="20">20 per page</option>
        <option value="30">30 per page</option>
      </Form.Select>
    </div>

    {/* Filter Button */}
    <button
      onClick={() => setShowFilterCard(!showFilterCard)}
      style={{
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        backgroundColor: showFilterCard ? '#223843' : '#ffffff',
        border: '1px solid #D1D3D4',
        color: showFilterCard ? '#ffffff' : '#223843',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'}}
    >
      <BsFunnelFill size={18} />
    </button>

  </div>

  {/* RIGHT SIDE */}
  <button
    onClick={() => navigate('/CreateBus')}
    style={{
      borderRadius: '10px',
      padding: '6px 12px',
      height: '44px',
      border: 'none',
      backgroundColor: '#223843',
      color: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      whiteSpace: 'nowrap'
    }}
  >
    <FaBus size={18} />
    <span style={{ fontSize: '12px', fontWeight: '600' }}>
      Add New Transport
    </span>
  </button>

</div>



                      
                         {/* Modern Filter Section */}
                                <div 
                                  style={{
                                    maxHeight: showFilterCard ? '1000px' : '0',
                                    overflow: 'hidden',
                                    transition: 'max-height 0.3s ease-in-out',
                                    marginBottom: showFilterCard ? '24px' : '0'}}
                                >
                                  {showFilterCard && (
                                    <Card 
                                      style={{
                                        border: '1px solid #D1D3D4',
                                        borderRadius: '12px',
                                        backgroundColor: '#ffffff',
                                        overflow: 'hidden'}}
                                    >
                                      {/* Header */}
                                      <div 
                                        style={{
                                          background: '#ffffff',
                                          padding: '20px',
                                          borderBottom: '1px solid #F3F4F6'}}
                                      >
                                        <div className="d-flex justify-content-between align-items-center">
                                          <div className="d-flex align-items-center gap-3">
                                            <div 
                                              style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                backgroundColor: '#223843',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'}}
                                            >
                                              <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                                            </div>
                                            <div>
                                              <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                                Search Transport
                                              </h5>
                                              <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                                                Find quickly by name, phone, or email
                                              </p>
                                            </div>
                                          </div>
                                          <div className="d-flex gap-2">
                                            <button
                                              onClick={handleRefresh}
                                              style={{
                                                width: '48px',
                                                height: '48px',
                                                borderRadius: '50%',
                                                backgroundColor: '#223843',
                                                border: 'none',
                                                color: '#ffffff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease'}}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#223843'
                                                e.currentTarget.style.transform = 'scale(1.05)'
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#223843'
                                                e.currentTarget.style.transform = 'scale(1)'
                                              }}
                                              title="Refresh"
                                            >
                                              <BsArrowClockwise size={20} />
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                      
                                      <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                                        <Row className="g-3">
                                          <Col xs={12}>
                                            <div style={{ position: 'relative' }}>
                                              <label className="fw-semibold text-start mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                                Search 
                                              </label>
                                              <div style={{ position: 'relative' }}>
                                                <BsSearch 
                                                  style={{ 
                                                    position: 'absolute', 
                                                    left: '12px', 
                                                    top: '50%', 
                                                    transform: 'translateY(-50%)',
                                                    color: '#6b7280',
                                                    fontSize: '16px',
                                                    zIndex: 1}} 
                                                />
                                                <Form.Control
                                                  type="text"
                                                  placeholder="Search by Vehicle Number or Driver Number"
                                                  value={search}
                                                  onChange={(e) => setSearch(e.target.value)}
                                                  style={{
                                                    paddingLeft: '40px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #D1D3D4',
                                                    fontSize: '14px',
                                                    height: '40px',
                                                    transition: 'all 0.2s ease',
                                                    backgroundColor: '#ffffff',
                                                    fontFamily: 'Inter, system-ui, sans-serif'}}
                                                  onFocus={(e) => {
                                                    e.target.style.borderColor = '#223843'
                                                  }}
                                                  onBlur={(e) => {
                                                    e.target.style.borderColor = '#D1D3D4'
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        
                                      </Card.Body>
                                      
                                    </Card>
                                    
                                    
                                  )}
                                </div>
                    


          

          <Card
            className="table-card"
            style={{
              border: '1px solid #D1D3D4',
              borderRadius: '12px',
              overflow: 'visible',
              backgroundColor: '#ffffff',
              position: 'relative'}}
          >
            <div
              className="table-wrapper"
              style={{
                overflowX: 'auto',
                overflowY: 'visible',
                position: 'relative',
                borderRadius: '12px'}}
            >
              <Table
                className="table mb-0"
                style={{
                  borderRadius: '12px',
                  overflow: 'visible',
                  position: 'relative',
                  marginBottom: '0'}}
              >
                <Thead>
                  <Tr style={{ backgroundColor: '#F3F4F6' }}>
                    {[
                      // 'ID',
                      'Vehicle Number',
                      // 'Bus Name',
                      'Driver Name',
                      'Driver Number',
                      'Owner Name',
                      'Bus attendant',
                      'Track Vehicle',
                      // 'Owner Number',
                      // 'Bus User',
                      // 'Status',
                      'Action',
                    ].map((h) => (
                      <Th
                        key={h}
                        style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          padding: '16px',
                          border: 'none',
                          borderBottom: '1px solid #D1D3D4',
                          textAlign: 'left',
                          color: '#111827',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap'}}
                      >
                        {h}
                      </Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>

                  { currentBuses.length===0 ?(
                    <Tr>
                      <Td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                      No buses found
                      </Td>
                    </Tr>
                  ): (
                    currentBuses.map((r, index) => (
                    <Tr
                      key={r.bus_id}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                        transition: 'background-color 0.2s ease',
                        borderBottom: '1px solid #E5E7EB'}}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor =
                          index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                      }}
                    >
                      {[
                        // r.bus_id,
                        r.bus_number,
                        // '-',
                        // r.bus_name,
                        r.driver_name,
                        r.driver_contact_number,
                        r.bus_owner_name,
                        r.bus_attendant_id == null
                          ? 'Not Assigned'
                          : attendantNamesById[r.bus_attendant_id] ??
                            attendantNamesById[String(r.bus_attendant_id)] ??
                            `User #${r.bus_attendant_id}`,
                        // r.bus_owner_number,
                        // '-',
                        // 'All',
                      ].map((val, i) => (
                        <Td
                          key={`${r.id}-${i}`}
                          style={{
                            fontSize: '14px',
                            padding: '16px',
                            border: 'none',
                            color: '#111827',
                            textAlign: 'left',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            whiteSpace: 'nowrap'}}
                        >
                          {val}
                        </Td>
                      ))}

                      <Td
                        style={{
                          fontSize: '14px',
                          padding: '16px',
                          border: 'none',
                          color: '#111827',
                          textAlign: 'left',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap',
                          verticalAlign: 'top'}}
                      >
                        <TrackVehicleButton
                          busId={r.bus_id}
                          attendantName={
                            r.bus_attendant_id == null
                              ? '—'
                              : attendantNamesById[r.bus_attendant_id] ??
                                attendantNamesById[String(r.bus_attendant_id)] ??
                                `User #${r.bus_attendant_id}`
                          }
                          busNumber={r.bus_number}
                          journeyActive={journeyActiveByBusId[Number(r.bus_id)]}
                          canManageJourney={
                            isBusAttendantUser(user) &&
                            Number(user?.id) === Number(r.bus_attendant_id)
                          }
                          inFlight={inFlight}
                          onOpenModal={handleTrackVehicle}
                          label="Track Vehicle"
                        />
                      </Td>

                      <Td
                        style={{
                          fontSize: '14px',
                          padding: '16px',
                          border: 'none',
                          color: '#111827',
                          textAlign: 'left',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap'}}
                      >
                        {isMobile ? (
                          <div className="d-flex gap-2 justify-content-center">
                                {/* <Button
                                  variant="outline-primary"
                                  size="sm"
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '8px',
                                    padding: 0}}
                                  onClick={() => handleView(r)}
                                >
                                  👁️
                                </Button> */}

                                <Button
                                  variant="outline-success"
                                  size="sm"
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '8px',
                                    padding: 0}}
                                  onClick={() => handleViewAssignedStd(r)}
                                >
                                  <GrView  size={18}/>
                                </Button>
                                <Button
                                  variant="outline-success"
                                  size="sm"
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '8px',
                                    padding: 0}}
                                  onClick={() => handleAssiginBustoStudent(r)}
                                >
                                  <MdAssignmentAdd size={18}/>
                                </Button>
                                <Button
                                  variant="outline-success"
                                  size="sm"
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '8px',
                                    padding: 0}}
                                  onClick={() => handleEdit(r)}
                                >
                                  <BsPencilFill size={18}/>
                                </Button>

                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '8px',
                                    padding: 0}}
                                  onClick={() => {
                                    setDeleteId(r.bus_id);
                                    setShowDeleteModal(true);
                                  }}
                                >
                                  <MdOutlineDeleteForever size={18}/>
                                </Button>
                              </div>
                            ) : (
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              id={`dropdown-bus-${r.id}`}
                            className="dropdown-toggle-no-caret"
                              style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                backgroundColor: 'transparent',
                                border: '1px solid #D1D3D4',
                                padding: 0,
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.2s ease'}}
                            >
                              <BsThreeDotsVertical />
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                borderRadius: '8px',
                                border: '1px solid #D1D3D4',
                                padding: '8px',
                                minWidth: '210px'}}
                            >
                  

                                  <Dropdown.Item onClick={() => handleViewAssignedStd(r)}
                                    style={{
                                  fontSize: '13px',
                                  padding: '10px 12px',
                                  color: '#111827',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'all 0.2s ease',
                                  borderRadius: '6px',
                                  fontFamily: 'Inter, system-ui, sans-serif'}}
                                 onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#10B981'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.color = '#111827'
                                }}
                                    >
                                       <GrView  size={18}/> View Assigned Student
                                   </Dropdown.Item>

                                  <Dropdown.Item onClick={()=>handleAssiginBustoStudent(r)}
                                    style={{
                                  fontSize: '13px',
                                  padding: '10px 12px',
                                  color: '#111827',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'all 0.2s ease',
                                  borderRadius: '6px',
                                  fontFamily: 'Inter, system-ui, sans-serif'}}
                                 onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#10B981'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.color = '#111827'
                                }}
                                    >
                                     <MdAssignmentAdd size={18}/>  Assign to Student
                                  </Dropdown.Item>

                                <Dropdown.Item 
                                    onClick={() => {
                                    handleEdit(r)
                                  }} 
                                  style={{
                                  fontSize: '13px',
                                  padding: '10px 12px',
                                  color: '#111827',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'all 0.2s ease',
                                  borderRadius: '6px',
                                  fontFamily: 'Inter, system-ui, sans-serif'}}
                                 onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#10B981'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.color = '#111827'
                                }}
                                >
                                <BsPencilFill size={18} /> Edit Vehicle
                              </Dropdown.Item>

                              <Dropdown.Item onClick={() => {
                                setDeleteId(r.bus_id);
                                setShowDeleteModal(true);
                              }}
                                style={{
                                  fontSize: '13px',
                                  padding: '10px 12px',
                                  color: '#111827',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'all 0.2s ease',
                                  borderRadius: '6px',
                                  fontFamily: 'Inter, system-ui, sans-serif'}}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#fd0b47'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.color = '#111827'
                                }}
                              >
                              <MdOutlineDeleteForever size={20}/> Delete
                            </Dropdown.Item>


                            </Dropdown.Menu>
                          </Dropdown>
                        )}


                      </Td>

                    </Tr>
                  )))}
                </Tbody>
              </Table>
            </div>
          </Card>

          {/* <div className="d-flex justify-content-between align-items-center mt-3">
   <div style={{ fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
    Showing {indexOfFirstItem + 1} to{" "}
    {Math.min(indexOfLastItem, filteredBuses.length)} of{" "}
    {filteredBuses.length} buses
  </div>

  <div className="d-flex gap-2">
    <button
      disabled={currentPage === 1}
      onClick={() => setCurrentPage((p) => p - 1)}
    >
      Prev
    </button>

    <span>Page {currentPage} of {totalPages}</span>

    <button
      disabled={currentPage === totalPages}
      onClick={() => setCurrentPage((p) => p + 1)}
    >
      Next
    </button>
  </div>
</div> */}

        <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={filteredBuses?.length || 0}
          className="d-flex justify-content-between align-items-center mb-3 mt-4"
          wrapperStyle={{ flexWrap: 'nowrap' }}
        />



  <EditBusModal
  show={showEditModal}
  handleClose={() => setShowEditModal(false)}
  bus={selectedBus}
  onUpdate={(updatedBus) => {
    setBuses((prev) =>
      prev.map((b) =>
        b.bus_id === selectedBus.bus_id ? { ...b, ...updatedBus } : b
      )
    );
  }}
/>


<DeleteBusModal
  show={showDeleteModal}
  handleClose={() => setShowDeleteModal(false)}
  deleteId={deleteId}
  busName={buses.find((b) => b.bus_id === deleteId)?.bus_number}
  onDelete={(id) => {
    setBuses((prev) => prev.filter((b) => b.bus_id !== id))
  }}
/>

        </Container>
      </div>
    </>
  )
}








































